function f(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var i = {}, c = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return l;
    }
  });
  function u(n, t) {
    return {
      handler: n,
      config: t
    };
  }
  u.withOptions = function(n, t = () => ({})) {
    const r = function(o) {
      return {
        __options: o,
        handler: n(o),
        config: t(o)
      };
    };
    return r.__isOptionsFunction = !0, r.__pluginFunction = n, r.__configFunction = t, r;
  };
  const l = u;
})(c);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const u = /* @__PURE__ */ l(c);
  function l(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  const n = u.default;
})(i);
let a = i;
var _ = (a.__esModule ? a : { default: a }).default;
const d = /* @__PURE__ */ f(_);
export {
  d as p
};
